import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { adminListPackages } from '../../api/packagesApi';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import CustomPlanFormFields from '../components/CustomPlanFormFields';
import {
  defaultCustomPlanFormData,
  formDataToTerms,
} from '../constants/customPlanFormConstants';
import { createCustomPlan } from '../services/customPlanApi';
import '../components/custom-plan-form.css';

export default function CustomPlanFormPage() {
  const navigate = useNavigate();
  const { admin } = useAdminAuth();
  const [formData, setFormData] = useState(defaultCustomPlanFormData);
  const [allPackages, setAllPackages] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadPackages = async () => {
      try {
        setAllPackages(await adminListPackages());
      } catch (err) {
        console.error('Error loading packages for feature library:', err);
      }
    };
    loadPackages();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const customerLabel = String(formData.customerLabel || '').trim();
    if (!customerLabel) {
      setError('Customer label is required.');
      return;
    }

    const terms = formDataToTerms(formData);
    if (!terms.planName || !Number.isFinite(terms.monthlyPrice) || terms.monthlyPrice <= 0) {
      setError('Enter a valid plan name and monthly price greater than zero.');
      return;
    }

    try {
      setSaving(true);
      setError('');
      const result = await createCustomPlan({ admin, customerLabel, terms });
      navigate(adminPath(`${ADMIN_PATHS.CUSTOM_PLANS}/${result.planId}`));
    } catch (err) {
      setError(err?.message || 'Failed to save plan');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h1 className="admin-page__title" style={{ fontSize: '22px', fontWeight: 750 }}>
          New custom plan
        </h1>
        <p className="admin-page__subtitle" style={{ margin: '6px 0 0', fontSize: '13px' }}>
          Step 1 — define the negotiated plan. You will send the invite from the next screen.
        </p>
      </div>

      {error && <div className="admin-alert admin-alert--error">{error}</div>}

      <form className="cp-detail-card" onSubmit={handleSubmit}>
        <CustomPlanFormFields
          formData={formData}
          setFormData={setFormData}
          allPackages={allPackages}
        />
        <div className="cp-detail-actions">
          <button type="button" className="admin-btn" onClick={() => navigate(adminPath(ADMIN_PATHS.CUSTOM_PLANS))}>
            Cancel
          </button>
          <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save draft'}
          </button>
        </div>
      </form>
    </div>
  );
}
